/**
 * ## Link Status
 * 
 * @type { PENDING | USED | EXPIRED | ACTIVE | INACTIVE }
 * 
 * @author Pedro Neves
 */
export enum LinkStatus{
    
    //* Direct Pay-By-Link

    /**
     * **Peding** - When the Link is still valid and is wating for Payment
     */
    PENDING = "PENDING",
    /**
     * **Used** - When the Link is not valid anymore and is was already payed
     */
    USED = "USED",
    /**
     * **Expired** - When the Link is not valid anymore and is wasn't payed
     */
    EXPIRED = "EXPIRED",


    //* Recurring Pay-By-Link

    /**
     * **Active** - When the Recurring Link is valid for payment
     */
    ACTIVE = "ACTIVE",
    /**
     * **Inactive** - When the Recurring Link is no longer valid for payment
     */
    INACTIVE = "INACTIVE"
}